import React from "react";
import styled from "styled-components";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import ExploreGraphic from "./explore-graphic";
import { Translation } from "../../../core/translate";
import { Button } from "@vitalsource/vstui";

const OuterContainer = styled.div`
  margin: auto;
  text-align: center;
  padding: 122px 50px;

  ${styledMedia.small`
    padding: 50px 30px;
  `}
`;

const StyledGraphic = styled(ExploreGraphic)`
  max-width: 100%;
  height: auto;
`;

const DescriptionText = styled.p`
  font-size: 1.6rem;
  font-weight: 500;
  padding-bottom: 40px;
  padding-top: 43px;
`;

export default ({ buttonText, description, onClick }) => (
  <OuterContainer>
    <StyledGraphic />
    <DescriptionText>
      <Translation id={description} />
    </DescriptionText>
    <Button onClick={onClick}>
      <Translation id={buttonText} />
    </Button>
  </OuterContainer>
);
